import moment from "moment";

export enum ETipoEmitenteMDFe {
  PrestadorServicoTransporte = 1,
  TransportadorCargaPropria = 2,
  PrestadorServicoCTeGlobalizado = 3,
}

export enum ETipoTransportadorMDFe {
  ETC = 1,
  TAC = 2,
  CTC = 3,
}

export enum ETipoProprietarioMDFe {
  TACAgregado = 0,
  TACIndependente = 1,
  Outros = 2,
}

export enum EModalMDFe {
  Rodoviario = 1,
  Aereo = 2,
  Aquaviario = 3,
  Ferroviario = 4,
}

export enum ETipoRodadoMDFe {
  Truck = 1,
  Toco = 2,
  CavaloMecanico = 3,
  VAN = 4,
  Utilitario = 5,
  Outros = 6,
}

export enum ETipoCarroceriaMDFe {
  NaoAplicavel = 0,
  Aberta = 1,
  FechadaBau = 2,
  Granelera = 3,
  PortaContainer = 4,
  Sider = 5,
}

export enum EStatusEnvioMDFe {
  Pendente = 1,
  Transmitido = 2,
  Rejeitado = 3,
  Autorizado = 4,
  Cancelado = 5,
  Encerrado = 6,
}

export enum ETipoEventoMDFe {
  Cancelamento = 110111,
  Encerramento = 110112,
  InclusaoCondutor = 110114,
}

export enum EResponsavelSeguroMDFe {
  EmitenteMDFe = 1,
  ResponsavelContratacao = 2,
}

export enum EUnidadeMedidaPesoMDFe {
  KG = 1,
  TON = 2,
}

export enum ETipoCargaMDFe {
  GranelSolido = 1,
  GranelLiquido = 2,
  Frigorificada = 3,
  Conteinerizada = 4,
  CargaGeral = 5,
  Neogranel = 6,
  PerigosaGranelSolido = 7,
  PerigosaGranelLiquido = 8,
  PerigosaFrigorificada = 9,
  PerigosaConteinerizada = 10,
  PerigosaCargaGeral = 11,
}

export enum EFormaPagamentoMDFe {
  AVista = 0,
  APrazo = 1,
}

export enum ETipoComponentePagamentoMDFe {
  ValePedagio = 1,
  ImpostosTaxasContribuicoes = 2,
  Despesas = 3,
  Frete = 4,
  Outros = 99,
}

export enum ETipoValePedagioMDFe {
  TagEletronica = "01",
  CupomVoucher = "02",
  CartaoMagnetico = "03",
}

export enum EIndicadorPagamentoBancarioMDFe {
  PIX = 1,
  TED = 2,
  DOC = 3,
  Outros = 99,
}

export const tipoEmitenteMDFeOptions = [
  { value: "1", label: "Prestador de Serviço de Transporte (CT-e)" },
  { value: "2", label: "Transportador de Carga Própria (NF-e)" },
  { value: "3", label: "Prestador de Serviço CTe Globalizado" },
];

export const tipoTransportadorMDFeOptions = [
  { value: "", label: "Não informado / Veículo Próprio (Frota Própria)" },
  { value: "1", label: "1 - ETC (Empresa de Transporte de Carga)" },
  { value: "2", label: "2 - TAC (Transportador Autônomo de Cargas)" },
  { value: "3", label: "3 - CTC (Cooperativa de Transporte de Cargas)" },
];

export const tipoProprietarioMDFeOptions = [
  { value: "0", label: "0 - TAC Agregado" },
  { value: "1", label: "1 - TAC Independente" },
  { value: "2", label: "2 - Outros" },
];

export const modalMDFeOptions = [
  { value: "1", label: "Rodoviário" },
  { value: "2", label: "Aéreo" },
  { value: "3", label: "Aquaviário" },
  { value: "4", label: "Ferroviário" },
];

export const tipoRodadoMDFeOptions = [
  { value: "1", label: "Truck" },
  { value: "2", label: "Toco" },
  { value: "3", label: "Cavalo Mecânico" },
  { value: "4", label: "VAN" },
  { value: "5", label: "Utilitário" },
  { value: "6", label: "Outros" },
];

export const tipoCarroceriaMDFeOptions = [
  { value: "0", label: "Não Aplicável" },
  { value: "1", label: "Aberta" },
  { value: "2", label: "Fechada / Baú" },
  { value: "3", label: "Graneleira" },
  { value: "4", label: "Porta-Container" },
  { value: "5", label: "Sider" },
];

export const statusEnvioMDFeOptions = [
  { value: "99", label: "Todos os Status" },
  { value: "1", label: "Pendente" },
  { value: "2", label: "Transmitido" },
  { value: "3", label: "Rejeitado" },
  { value: "4", label: "Autorizado" },
  { value: "5", label: "Cancelado" },
  { value: "6", label: "Encerrado" },
];

export const statusEnvioMDFeDescricao: Record<number, string> = {
  [EStatusEnvioMDFe.Pendente]: "Pendente",
  [EStatusEnvioMDFe.Transmitido]: "Transmitido",
  [EStatusEnvioMDFe.Rejeitado]: "Rejeitado",
  [EStatusEnvioMDFe.Autorizado]: "Autorizado",
  [EStatusEnvioMDFe.Cancelado]: "Cancelado",
  [EStatusEnvioMDFe.Encerrado]: "Encerrado",
};

export const getDescricaoStatusEnvioMDFe = (
  codigoStatus?: number | EStatusEnvioMDFe | null,
  descricaoCustomizada?: string | null
): string => {
  if (descricaoCustomizada && descricaoCustomizada.trim() !== "") {
    return descricaoCustomizada;
  }
  const cod = Number(codigoStatus);
  if (statusEnvioMDFeDescricao[cod]) {
    return statusEnvioMDFeDescricao[cod];
  }
  return "Pendente";
};

export interface VisualStatusConfigMDFe {
  categoria:
    | "nao_enviado"
    | "enviado_aberto"
    | "enviado_encerrado"
    | "cancelado"
    | "rejeitado";
  label: string;
  badgeBg: string;
  badgeText?: string;
  borderClass: string;
  iconSymbol: string;
}

export const getVisualStatusMDFe = (
  codigoStatusEnvio?: number | EStatusEnvioMDFe | null,
  codigoStatusResposta?: number | null
): VisualStatusConfigMDFe => {
  const cod = Number(codigoStatusEnvio ?? EStatusEnvioMDFe.Pendente);

  if (cod === EStatusEnvioMDFe.Encerrado) {
    return {
      categoria: "enviado_encerrado",
      label: "Encerrado",
      badgeBg: "secondary",
      badgeText: "white",
      borderClass: "border-secondary",
      iconSymbol: "✓",
    };
  }

  if (cod === EStatusEnvioMDFe.Cancelado) {
    return {
      categoria: "cancelado",
      label: "Cancelado",
      badgeBg: "danger",
      badgeText: "white",
      borderClass: "border-danger",
      iconSymbol: "✕",
    };
  }

  if (cod === EStatusEnvioMDFe.Rejeitado) {
    return {
      categoria: "rejeitado",
      label: "Rejeitado",
      badgeBg: "danger",
      badgeText: "white",
      borderClass: "border-danger",
      iconSymbol: "⚠",
    };
  }

  if (
    cod === EStatusEnvioMDFe.Autorizado ||
    cod === EStatusEnvioMDFe.Transmitido ||
    codigoStatusResposta === 100
  ) {
    return {
      categoria: "enviado_aberto",
      label: "Enviado (Em Aberto)",
      badgeBg: "success",
      badgeText: "white",
      borderClass: "border-success",
      iconSymbol: "🚚",
    };
  }

  return {
    categoria: "nao_enviado",
    label: "Não Enviado",
    badgeBg: "warning",
    badgeText: "dark",
    borderClass: "border-warning",
    iconSymbol: "⏳",
  };
};

export const responsavelSeguroMDFeOptions = [
  { value: "1", label: "Emitente do MDF-e" },
  { value: "2", label: "Responsável pela Contratação" },
];

export const unidadeMedidaPesoMDFeOptions = [
  { value: "1", label: "KG - Quilogramas" },
  { value: "2", label: "TON - Toneladas" },
];

export const tipoDocumentoMDFeOptions = [
  { value: "1", label: "CT-e (Modelo 57)" },
  { value: "2", label: "NF-e (Modelo 55)" },
];

export const tipoCargaMDFeOptions = [
  { value: "1", label: "01 - Granel Sólido" },
  { value: "2", label: "02 - Granel Líquido" },
  { value: "3", label: "03 - Frigorificada" },
  { value: "4", label: "04 - Conteinerizada" },
  { value: "5", label: "05 - Carga Geral" },
  { value: "6", label: "06 - Neogranel" },
  { value: "7", label: "07 - Perigosa (Granel Sólido)" },
  { value: "8", label: "08 - Perigosa (Granel Líquido)" },
  { value: "9", label: "09 - Perigosa (Frigorificada)" },
  { value: "10", label: "10 - Perigosa (Conteinerizada)" },
  { value: "11", label: "11 - Perigosa (Carga Geral)" },
];

export const formaPagamentoMDFeOptions = [
  { value: "0", label: "À Vista" },
  { value: "1", label: "A Prazo" },
];

export const tipoComponentePagamentoMDFeOptions = [
  { value: "1", label: "01 - Vale Pedágio" },
  { value: "2", label: "02 - Impostos, Taxas e Contribuições" },
  { value: "3", label: "03 - Despesas (Bancárias, Meios de Pagamento, outras)" },
  { value: "4", label: "04 - Frete" },
  { value: "99", label: "99 - Outros (Frete peso, etc.)" },
];

export const tipoValePedagioMDFeOptions = [
  { value: "01", label: "01 - Tag Eletrônica" },
  { value: "02", label: "02 - Cupom / Voucher" },
  { value: "03", label: "03 - Cartão Magnético" },
];

export interface CategoriaCombinacaoVeicularItem {
  codigo: string;
  descricao: string;
}

export const tabelaCategoriasCombinacaoVeicular: CategoriaCombinacaoVeicularItem[] = [
  { codigo: "02", descricao: "02 – Veículo Comercial 2 eixos" },
  { codigo: "04", descricao: "04 – Veículo Comercial 3 eixos" },
  { codigo: "06", descricao: "06 – Veículo Comercial 4 eixos" },
  { codigo: "07", descricao: "07 – Veículo Comercial 5 eixos" },
  { codigo: "08", descricao: "08 – Veículo Comercial 6 eixos" },
  { codigo: "10", descricao: "10 – Veículo Comercial 7 eixos" },
  { codigo: "11", descricao: "11 – Veículo Comercial 8 eixos" },
  { codigo: "12", descricao: "12 – Veículo Comercial 9 eixos" },
  { codigo: "13", descricao: "13 – Veículo Comercial 10 eixos" },
  { codigo: "14", descricao: "14 – Veículo Comercial Acima de 10 eixos" },
];

export const categoriaCombinacaoVeicularOptions = [
  { value: "", label: "Selecione a categoria..." },
  ...tabelaCategoriasCombinacaoVeicular.map((c) => ({
    value: c.codigo,
    label: c.descricao,
  })),
];

export const obterDescricaoCategoriaCombinacaoVeicular = (
  codigo?: string | null
): string => {
  if (!codigo) return "";
  const limpo = String(codigo).trim();
  const item = tabelaCategoriasCombinacaoVeicular.find((c) => c.codigo === limpo);
  return item ? item.descricao : "";
};

export const indicadorPagamentoBancarioMDFeOptions = [
  { value: "1", label: "01 - PIX" },
  { value: "2", label: "02 - TED" },
  { value: "3", label: "03 - DOC" },
  { value: "99", label: "99 - Outros" },
];

export enum ETipoOperacaoCIOT {
  CargaLotacao = 1,
  CargaFracionada = 2,
  TacAgregado = 3,
}

export enum ETipoCargaCIOT {
  GranelSolido = 1,
  GranelLiquido = 2,
  Frigorificada = 3,
  Conteinerizada = 4,
  CargaGeral = 5,
  Neogranel = 6,
  PerigosaGranelSolido = 7,
  PerigosaGranelLiquido = 8,
  PerigosaFrigorificada = 9,
  PerigosaConteinerizada = 10,
  PerigosaCargaGeral = 11,
  CargaGranelPressurizada = 12,
}

export enum ETipoPagamentoCIOT {
  InstituicaoPagamento = 1,
  ContaCorrente = 2,
  ContaPoupanca = 3,
  ContaPagamento = 4,
  Outros = 5,
  Pix = 6,
}

export enum EStatusCIOT {
  PendenteVinculo = 0,
  Vinculado = 1,
  Cancelado = 2,
  Expirado = 3,
}

export const tipoOperacaoCIOTOptions = [
  { value: "1", label: "1 - Carga Lotação" },
  { value: "2", label: "2 - Carga Fracionada" },
  { value: "3", label: "3 - TAC-Agregado" },
];

export const tipoCargaCIOTOptions = [
  ...tipoCargaMDFeOptions,
  { value: "12", label: "12 - Carga Granel Pressurizada" },
];

export const tipoPagamentoCIOTOptions = [
  { value: "1", label: "1 - Instituição de Pagamento (cartão pré-pago)" },
  { value: "2", label: "2 - Conta Corrente" },
  { value: "3", label: "3 - Conta Poupança" },
  { value: "4", label: "4 - Conta Pagamento" },
  { value: "5", label: "5 - Outros" },
  { value: "6", label: "6 - Pix" },
];

export const ufOptions = [
  { value: "", label: "Selecione a UF" },
  { value: "AC", label: "AC" },
  { value: "AL", label: "AL" },
  { value: "AP", label: "AP" },
  { value: "AM", label: "AM" },
  { value: "BA", label: "BA" },
  { value: "CE", label: "CE" },
  { value: "DF", label: "DF" },
  { value: "ES", label: "ES" },
  { value: "GO", label: "GO" },
  { value: "MA", label: "MA" },
  { value: "MT", label: "MT" },
  { value: "MS", label: "MS" },
  { value: "MG", label: "MG" },
  { value: "PA", label: "PA" },
  { value: "PB", label: "PB" },
  { value: "PR", label: "PR" },
  { value: "PE", label: "PE" },
  { value: "PI", label: "PI" },
  { value: "RJ", label: "RJ" },
  { value: "RN", label: "RN" },
  { value: "RS", label: "RS" },
  { value: "RO", label: "RO" },
  { value: "RR", label: "RR" },
  { value: "SC", label: "SC" },
  { value: "SP", label: "SP" },
  { value: "SE", label: "SE" },
  { value: "TO", label: "TO" },
];

export const ufToCodigoIbge: Record<string, number> = {
  RO: 11,
  AC: 12,
  AM: 13,
  RR: 14,
  PA: 15,
  AP: 16,
  TO: 17,
  MA: 21,
  PI: 22,
  CE: 23,
  RN: 24,
  PB: 25,
  PE: 26,
  AL: 27,
  SE: 28,
  BA: 29,
  MG: 31,
  ES: 32,
  RJ: 33,
  SP: 35,
  PR: 41,
  SC: 42,
  RS: 43,
  MS: 50,
  MT: 51,
  GO: 52,
  DF: 53,
};

export const codigoIbgeToUf: Record<number, string> = {
  11: "RO",
  12: "AC",
  13: "AM",
  14: "RR",
  15: "PA",
  16: "AP",
  17: "TO",
  21: "MA",
  22: "PI",
  23: "CE",
  24: "RN",
  25: "PB",
  26: "PE",
  27: "AL",
  28: "SE",
  29: "BA",
  31: "MG",
  32: "ES",
  33: "RJ",
  35: "SP",
  41: "PR",
  42: "SC",
  43: "RS",
  50: "MS",
  51: "MT",
  52: "GO",
  53: "DF",
};

export const obterCodigoIbgeUf = (uf?: string | null): number | undefined => {
  if (!uf) return undefined;
  return ufToCodigoIbge[uf.trim().toUpperCase()];
};

export const obterSiglaUfPorCodigoIbge = (codigoUf?: number | null): string | undefined => {
  if (!codigoUf) return undefined;
  return codigoIbgeToUf[codigoUf];
};

export const obterUfPorCodigoMunicipio = (
  codigoMunicipio?: number | string | null
): string | undefined => {
  if (!codigoMunicipio) return undefined;
  const codNum = Number(codigoMunicipio);
  if (isNaN(codNum) || codNum < 1000000 || codNum > 9999999) return undefined;
  const prefixoUf = Math.floor(codNum / 100000);
  return codigoIbgeToUf[prefixoUf];
};

export const validarMunicipioPertenceUf = (
  codigoMunicipio?: number | string | null,
  uf?: string | null
): boolean => {
  if (!codigoMunicipio || !uf) return true;
  const codNum = Number(codigoMunicipio);
  if (isNaN(codNum) || codNum < 1000000 || codNum > 9999999) return true;
  const ufClean = uf.trim().toUpperCase();
  const ufCodigoEsperado = ufToCodigoIbge[ufClean];
  if (!ufCodigoEsperado) return true;
  const prefixoUf = Math.floor(codNum / 100000);
  return prefixoUf === ufCodigoEsperado;
};

export interface MDFeMunicipioCarregamentoInput {
  codigoMunicipioCarregamento: number;
  nomeMunicipioCarregamento: string;
}

export interface MDFePercursoInput {
  ufPercurso: string;
  sequencia: number;
}

export interface MDFeDocumentoItemInput {
  chaveAcesso: string;
  segundoCodigoBarras?: string;
  indicadorReentrega?: boolean;
  tipoDocumento: number;
}

export interface MDFeMunicipioDescargaInput {
  codigoMunicipioDescarga: number;
  nomeMunicipioDescarga: string;
  documentos: MDFeDocumentoItemInput[];
}

export interface MDFeCondutorInput {
  nomeCondutor: string;
  cpfCondutor: string;
}

export interface MDFeProprietarioVeiculoInput {
  documento?: string;
  cpf?: string;
  cnpj?: string;
  rntrc: string;
  nome: string;
  ie?: string;
  uf: string;
  tipoProprietario: ETipoProprietarioMDFe;
}

export interface MDFeProprietarioVeiculoOutput {
  documento?: string;
  cpf?: string;
  cnpj?: string;
  rntrc: string;
  nome: string;
  ie?: string;
  uf: string;
  tipoProprietario: ETipoProprietarioMDFe;
}

export interface MDFeReboqueInput {
  codigoInterno?: string;
  placa: string;
  renavam?: string;
  tara: number;
  capacidadeKG: number;
  capacidadeM3?: number;
  tipoCarroceria: ETipoCarroceriaMDFe;
  uf: string;
}

export interface MDFeSeguroInput {
  responsavelSeguro: EResponsavelSeguroMDFe;
  documentoResponsavel?: string;
  nomeSeguradora: string;
  cnpjSeguradora: string;
  numeroApolice?: string;
  numeroAverbaCorrente?: string;
}

export interface MDFeProdutoPredominanteInput {
  tipoCarga: ETipoCargaMDFe;
  nomeProduto: string;
  codigoEAN?: string;
  ncm?: string;
  cepCarregamento?: string;
  cepDescarregamento?: string;
}

export interface MDFeCiotInput {
  ciot: string;
  documento?: string;
  cpf?: string;
  cnpj?: string;
}

export interface MDFeValePedagioInput {
  nomeFornecedoraValePedagio?: string;
  cnpjEmitenteValePedagio?: string;
  documentoResponsavelPagamento?: string;
  nomeResponsavelPagamento?: string;
  cnpjResponsavelPagamento?: string;
  cpfResponsavelPagamento?: string;
  numeroComprovante: string;
  valorValePedagio: number;
  tipoValePedagio?: ETipoValePedagioMDFe;
  categoriaCombinacaoVeicular?: string;
}

export interface MDFeContratanteInput {
  nomeContratante?: string;
  documento?: string;
  cpf?: string;
  cnpj?: string;
  idEstrangeiro?: string;
}

export interface MDFePagamentoComponenteInput {
  tipoComponente: ETipoComponentePagamentoMDFe;
  valorComponente: number;
  descricaoOutro?: string;
}

export interface MDFePagamentoParcelaInput {
  numeroParcela: number;
  dataVencimento: string;
  valorParcela: number;
}

export interface MDFePagamentoInput {
  nomeBeneficiario?: string;
  documento?: string;
  cpfBeneficiario?: string;
  cnpjBeneficiario?: string;
  idEstrangeiroBeneficiario?: string;
  valorTotalContrato: number;
  formaPagamento: EFormaPagamentoMDFe;
  documentoResponsavelPagamento?: string;
  cnpjResponsavelPagamento?: string;
  cpfResponsavelPagamento?: string;
  idEstrangeiroResponsavelPagamento?: string;
  cnpjInstituicaoPagamento?: string;
  chavePixBancario?: string;
  valorAdiantamento?: number;
  tipoAntecipacao?: number;
  codigoBanco?: string;
  codigoAgencia?: string;
  indicadorPagamentoBancario?: number;
  componentes: MDFePagamentoComponenteInput[];
  parcelas?: MDFePagamentoParcelaInput[];
}

export interface MDFeInput {
  id?: number;
  serie: number;
  numeroMDFe?: number;
  emissaoDataHora?: string;
  tipoEmitente: ETipoEmitenteMDFe;
  tipoTransportador?: ETipoTransportadorMDFe;
  modal: EModalMDFe;
  ufInicio: string;
  ufFim: string;
  previsaoInicioViagemDataHora?: string;
  rntrc?: string;

  placaVeiculoTracao: string;
  renavamVeiculoTracao?: string;
  taraVeiculoTracao: number;
  capacidadeKGVeiculoTracao?: number;
  capacidadeM3VeiculoTracao?: number;
  tipoRodadoVeiculoTracao: ETipoRodadoMDFe;
  tipoCarroceriaVeiculoTracao: ETipoCarroceriaMDFe;
  ufVeiculoTracao: string;
  proprietarioVeiculoTracao?: MDFeProprietarioVeiculoInput;
  quantidadeCTe?: number;
  quantidadeNFe?: number;
  quantidadeMDFe?: number;
  valorTotalCarga?: number;
  pesoBrutoTotal?: number;
  unidadeMedidaPeso?: EUnidadeMedidaPesoMDFe;

  informacoesAdicionaisFisco?: string;
  informacoesComplementaresContribuinte?: string;

  municipiosCarregamento: MDFeMunicipioCarregamentoInput[];
  percursos?: MDFePercursoInput[];
  municipiosDescarga: MDFeMunicipioDescargaInput[];
  condutores: MDFeCondutorInput[];
  reboques?: MDFeReboqueInput[];
  seguros?: MDFeSeguroInput[];
  produtoPredominante?: MDFeProdutoPredominanteInput;
  ciots?: MDFeCiotInput[];
  cioTs?: MDFeCiotInput[];
  valesPedagio?: MDFeValePedagioInput[];
  contratantes?: MDFeContratanteInput[];
  pagamentos?: MDFePagamentoInput[];
  autorizacao?: MDFeAutorizacaoOutput;
}

export interface MDFeAutorizacaoOutput {
  id: number;
  chaveAcesso: string;
  codigoStatusEnvio: EStatusEnvioMDFe;
  descricaoStatusEnvio?: string;
  codigoStatusResposta?: number;
  numeroProtocolo?: string;
  descricaoMotivoResposta?: string;
  recebimentoDataHora?: string;
}

export interface MDFeOutput {
  id: number;
  serie: number;
  numeroMDFe: number;
  emissaoDataHora: string;
  tipoEmitente: ETipoEmitenteMDFe;
  tipoTransportador?: ETipoTransportadorMDFe;
  modal: EModalMDFe;
  ufInicio: string;
  ufFim: string;
  previsaoInicioViagemDataHora?: string;
  rntrc?: string;

  placaVeiculoTracao: string;
  renavamVeiculoTracao?: string;
  taraVeiculoTracao: number;
  capacidadeKGVeiculoTracao?: number;
  capacidadeM3VeiculoTracao?: number;
  tipoRodadoVeiculoTracao: ETipoRodadoMDFe;
  tipoCarroceriaVeiculoTracao: ETipoCarroceriaMDFe;
  ufVeiculoTracao: string;
  proprietarioVeiculoTracao?: MDFeProprietarioVeiculoOutput;

  documentoProprietarioVeiculoTracao?: string;
  cpfProprietarioVeiculoTracao?: string;
  cnpjProprietarioVeiculoTracao?: string;
  rntrcProprietarioVeiculoTracao?: string;
  nomeProprietarioVeiculoTracao?: string;
  ieProprietarioVeiculoTracao?: string;
  ufProprietarioVeiculoTracao?: string;
  tipoProprietarioVeiculoTracao?: number;

  quantidadeCTe?: number;
  quantidadeNFe?: number;
  quantidadeMDFe?: number;
  valorTotalCarga?: number;
  pesoBrutoTotal?: number;
  unidadeMedidaPeso?: EUnidadeMedidaPesoMDFe;

  informacoesAdicionaisFisco?: string;
  informacoesComplementaresContribuinte?: string;

  autorizacao?: MDFeAutorizacaoOutput;

  municipiosCarregamento?: MDFeMunicipioCarregamentoInput[];
  percursos?: MDFePercursoInput[];
  municipiosDescarga?: MDFeMunicipioDescargaInput[];
  condutores?: MDFeCondutorInput[];
  reboques?: MDFeReboqueInput[];
  seguros?: MDFeSeguroInput[];
  produtoPredominante?: MDFeProdutoPredominanteInput;
  ciots?: MDFeCiotInput[];
  cioTs?: MDFeCiotInput[];
  valesPedagio?: MDFeValePedagioInput[];
  contratantes?: MDFeContratanteInput[];
  pagamentos?: MDFePagamentoInput[];
}

export interface MDFeFiltrarDto {
  id?: number | null;
  serie?: number | null;
  numeroMDFe?: number | null;
  placa?: string | null;
  codigoStatusEnvio?: string | number | null;
  dataEmissaoInicial?: Date | null;
  dataEmissaoFinal?: Date | null;
}

export interface MDFeNaoEncerradoItemOutput {
  chaveAcesso: string;
  numeroProtocolo: string;
}

export const STORAGEMDFE_KEY = "mdfe_draft";

export function getLocal<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Erro ao ler do localStorage", error);
    return null;
  }
}

export function updateLocal<T>(key: string, data: Partial<T> | null): void {
  try {
    if (data === null) {
      localStorage.removeItem(key);
      return;
    }
    const current = getLocal<T>(key) || ({} as T);
    const updated = { ...current, ...data };
    localStorage.setItem(key, JSON.stringify(updated));
  } catch (error) {
    console.error("Erro ao atualizar localStorage", error);
  }
}

export function formatarPayloadMDFe(input: MDFeInput): MDFeInput {
  const payload: MDFeInput = JSON.parse(JSON.stringify(input));

  // 1. Remover ID para inclusão nova
  delete payload.id;
  delete (payload as any).autorizacao;

  // 2. Previsão de início da viagem -> Formato ISO-8601 exigido pelo ASP.NET Core (DateTime?)
  if (
    payload.previsaoInicioViagemDataHora &&
    String(payload.previsaoInicioViagemDataHora).trim() !== ""
  ) {
    const mPrevisao = moment(payload.previsaoInicioViagemDataHora, [
      "YYYY-MM-DDTHH:mm:ss",
      "DD/MM/YYYY HH:mm:ss",
      "DD/MM/YYYY HH:mm",
      moment.ISO_8601,
    ]);
    if (mPrevisao.isValid()) {
      payload.previsaoInicioViagemDataHora = mPrevisao.format("YYYY-MM-DDTHH:mm:ss");
    } else {
      delete payload.previsaoInicioViagemDataHora;
    }
  } else {
    delete payload.previsaoInicioViagemDataHora;
  }

  // 3. Data de emissão -> ISO-8601
  if (
    payload.emissaoDataHora &&
    String(payload.emissaoDataHora).trim() !== ""
  ) {
    const mEmissao = moment(payload.emissaoDataHora, [
      "YYYY-MM-DDTHH:mm:ss",
      "DD/MM/YYYY HH:mm:ss",
      "DD/MM/YYYY HH:mm",
      moment.ISO_8601,
    ]);
    if (mEmissao.isValid()) {
      payload.emissaoDataHora = mEmissao.format("YYYY-MM-DDTHH:mm:ss");
    } else {
      payload.emissaoDataHora = moment().format("YYYY-MM-DDTHH:mm:ss");
    }
  } else {
    payload.emissaoDataHora = moment().format("YYYY-MM-DDTHH:mm:ss");
  }

  // 4. Numéricos essenciais
  payload.serie = Number(payload.serie) || 1;
  payload.numeroMDFe = Number(payload.numeroMDFe) || 0;
  payload.tipoEmitente = Number(payload.tipoEmitente);
  payload.modal = Number(payload.modal) || 1;
  payload.tipoRodadoVeiculoTracao = Number(payload.tipoRodadoVeiculoTracao);
  payload.tipoCarroceriaVeiculoTracao = Number(payload.tipoCarroceriaVeiculoTracao);
  payload.taraVeiculoTracao = Number(payload.taraVeiculoTracao);

  if (payload.capacidadeKGVeiculoTracao) {
    payload.capacidadeKGVeiculoTracao = Number(payload.capacidadeKGVeiculoTracao);
  } else {
    delete payload.capacidadeKGVeiculoTracao;
  }

  if (payload.capacidadeM3VeiculoTracao) {
    payload.capacidadeM3VeiculoTracao = Number(payload.capacidadeM3VeiculoTracao);
  } else {
    delete payload.capacidadeM3VeiculoTracao;
  }

  if (payload.valorTotalCarga !== undefined && payload.valorTotalCarga !== null) {
    payload.valorTotalCarga = Number(payload.valorTotalCarga);
  } else {
    delete payload.valorTotalCarga;
  }

  if (payload.pesoBrutoTotal !== undefined && payload.pesoBrutoTotal !== null) {
    payload.pesoBrutoTotal = Number(payload.pesoBrutoTotal);
  } else {
    delete payload.pesoBrutoTotal;
  }

  if (payload.unidadeMedidaPeso) {
    payload.unidadeMedidaPeso = Number(payload.unidadeMedidaPeso);
  } else {
    delete payload.unidadeMedidaPeso;
  }

  // 5. RNTRC (remover pontuações e manter apenas dígitos)
  if (payload.rntrc) {
    payload.rntrc = String(payload.rntrc).replace(/\D/g, "");
    if (!payload.rntrc) delete payload.rntrc;
  } else {
    delete payload.rntrc;
  }

  // 6. Placas e Renavam
  if (payload.placaVeiculoTracao) {
    payload.placaVeiculoTracao = payload.placaVeiculoTracao.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  }
  if (payload.renavamVeiculoTracao) {
    payload.renavamVeiculoTracao = payload.renavamVeiculoTracao.replace(/\D/g, "");
    if (!payload.renavamVeiculoTracao) delete payload.renavamVeiculoTracao;
  } else {
    delete payload.renavamVeiculoTracao;
  }

  // 6b. Proprietário do Veículo de Tração (Opcional - somente se veículo de terceiro)
  // Rejeição 745: O tipo de transportador não pode ser informado quando não estiver informado proprietário do veículo de tração.
  const propInput = payload.proprietarioVeiculoTracao;
  const docPropRaw = propInput?.documento || propInput?.cpf || propInput?.cnpj;
  const temProprietario = Boolean(
    propInput &&
      docPropRaw?.trim() &&
      propInput.nome?.trim()
  );

  if (temProprietario && propInput) {
    const docLimpo = docPropRaw ? docPropRaw.replace(/[.\-/\s]/g, "").toUpperCase() : "";
    const prop: MDFeProprietarioVeiculoInput = {
      documento: docLimpo,
      nome: propInput.nome.trim().toUpperCase(),
      rntrc: String(propInput.rntrc || "").replace(/\D/g, "").slice(0, 8),
      uf: String(propInput.uf || "").toUpperCase().trim().slice(0, 2),
      tipoProprietario: Number(propInput.tipoProprietario) || 0,
    };
    if (docLimpo.length === 11) {
      prop.cpf = docLimpo;
    } else if (docLimpo.length === 14) {
      prop.cnpj = docLimpo;
    }
    if (propInput.ie?.trim()) {
      const ie = propInput.ie.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
      if (ie) prop.ie = ie;
    }
    payload.proprietarioVeiculoTracao = prop;

    // Se possui proprietário, tipoTransportador pode ser mantido se informado
    if (payload.tipoTransportador) {
      payload.tipoTransportador = Number(payload.tipoTransportador);
    } else {
      delete payload.tipoTransportador;
    }
  } else {
    delete payload.proprietarioVeiculoTracao;
    // Sem proprietário de veículo de tração, tipoTransportador não pode ser informado (Rejeição 745)
    delete payload.tipoTransportador;
  }

  // 7. Percursos intermediários
  if (payload.percursos && payload.percursos.length > 0) {
    payload.percursos = payload.percursos.map((p, idx) => ({
      ufPercurso: p.ufPercurso.toUpperCase(),
      sequencia: Number(p.sequencia) || idx + 1,
    }));
  } else {
    delete payload.percursos;
  }

  // 8. Reboques opcionais
  if (payload.reboques && payload.reboques.length > 0) {
    payload.reboques = payload.reboques.map((r) => {
      const reb: any = {
        placa: r.placa.replace(/[^a-zA-Z0-9]/g, "").toUpperCase(),
        tara: Number(r.tara),
        tipoCarroceria: Number(r.tipoCarroceria),
        uf: r.uf.toUpperCase(),
      };
      if (r.codigoInterno?.trim()) reb.codigoInterno = r.codigoInterno.trim();
      if (r.renavam?.trim()) reb.renavam = r.renavam.replace(/\D/g, "");
      if (r.capacidadeKG) reb.capacidadeKG = Number(r.capacidadeKG);
      if (r.capacidadeM3) reb.capacidadeM3 = Number(r.capacidadeM3);
      return reb;
    });
  } else {
    delete payload.reboques;
  }

  // 9. Seguros
  if (payload.seguros && payload.seguros.length > 0) {
    const segurosValidos = payload.seguros.filter(
      (s) =>
        s.nomeSeguradora?.trim() ||
        s.cnpjSeguradora?.trim() ||
        s.documentoResponsavel?.trim() ||
        s.numeroApolice?.trim() ||
        s.numeroAverbaCorrente?.trim()
    );
    if (segurosValidos.length > 0) {
      payload.seguros = segurosValidos.map((s) => {
        const seg: any = {
          responsavelSeguro: Number(s.responsavelSeguro) || 1,
          nomeSeguradora: s.nomeSeguradora?.trim() || "",
          cnpjSeguradora: s.cnpjSeguradora
            ? s.cnpjSeguradora.replace(/[^A-Za-z0-9]/g, "").toUpperCase()
            : "",
          numeroApolice: s.numeroApolice?.trim() || "",
          numeroAverbaCorrente: s.numeroAverbaCorrente?.trim() || "",
        };
        if (s.documentoResponsavel?.trim()) {
          seg.documentoResponsavel = s.documentoResponsavel
            .replace(/[^A-Za-z0-9]/g, "")
            .toUpperCase();
        }
        return seg;
      });
    } else {
      delete payload.seguros;
    }
  } else {
    delete payload.seguros;
  }

  // 10. Condutores
  if (payload.condutores && payload.condutores.length > 0) {
    payload.condutores = payload.condutores.map((c) => ({
      nomeCondutor: c.nomeCondutor.trim(),
      cpfCondutor: c.cpfCondutor.replace(/\D/g, ""),
    }));
  }

  // 11. Municípios de Carregamento
  if (payload.municipiosCarregamento) {
    payload.municipiosCarregamento = payload.municipiosCarregamento.map((c) => ({
      codigoMunicipioCarregamento: Number(c.codigoMunicipioCarregamento),
      nomeMunicipioCarregamento: c.nomeMunicipioCarregamento.trim(),
    }));
  }

  // 12. Municípios de Descarga e Documentos
  if (payload.municipiosDescarga) {
    payload.municipiosDescarga = payload.municipiosDescarga.map((d) => ({
      codigoMunicipioDescarga: Number(d.codigoMunicipioDescarga),
      nomeMunicipioDescarga: d.nomeMunicipioDescarga.trim(),
      documentos: (d.documentos || []).map((doc) => {
        const item: any = {
          chaveAcesso: doc.chaveAcesso.replace(/\D/g, ""),
          tipoDocumento: Number(doc.tipoDocumento),
          indicadorReentrega: Boolean(doc.indicadorReentrega),
        };
        if (doc.segundoCodigoBarras?.trim()) {
          item.segundoCodigoBarras = doc.segundoCodigoBarras.trim();
        }
        return item;
      }),
    }));
  }

  // 13. Informações adicionais
  if (!payload.informacoesAdicionaisFisco?.trim()) {
    delete payload.informacoesAdicionaisFisco;
  }
  if (!payload.informacoesComplementaresContribuinte?.trim()) {
    delete payload.informacoesComplementaresContribuinte;
  }

  // 14. Produto Predominante (NT 2025.001 - Regra F55a)
  if (
    payload.produtoPredominante &&
    payload.produtoPredominante.nomeProduto &&
    payload.produtoPredominante.nomeProduto.trim() !== ""
  ) {
    const prod: any = {
      tipoCarga: Number(payload.produtoPredominante.tipoCarga) || 5,
      nomeProduto: payload.produtoPredominante.nomeProduto.trim().toUpperCase(),
    };
    if (payload.produtoPredominante.codigoEAN?.trim()) {
      const trimmed = payload.produtoPredominante.codigoEAN.trim().toUpperCase();
      if (trimmed === "SEM GTIN") {
        prod.codigoEAN = "SEM GTIN";
      } else {
        const ean = payload.produtoPredominante.codigoEAN.replace(/\D/g, "");
        if (ean) prod.codigoEAN = ean;
      }
    }
    if (payload.produtoPredominante.ncm?.trim()) {
      const ncm = payload.produtoPredominante.ncm.replace(/\D/g, "");
      if (ncm) prod.ncm = ncm;
    }
    if (payload.produtoPredominante.cepCarregamento?.trim()) {
      const cepC = payload.produtoPredominante.cepCarregamento.replace(/\D/g, "");
      if (cepC) prod.cepCarregamento = cepC;
    }
    if (payload.produtoPredominante.cepDescarregamento?.trim()) {
      const cepD = payload.produtoPredominante.cepDescarregamento.replace(/\D/g, "");
      if (cepD) prod.cepDescarregamento = cepD;
    }
    payload.produtoPredominante = prod;
  } else {
    delete payload.produtoPredominante;
  }

  // 15. CIOTs (ANTT)
  const ciotsOriginais = payload.ciots || (payload as any).cioTs;
  if (ciotsOriginais && ciotsOriginais.length > 0) {
    const ciotsValidos = ciotsOriginais
      .map((c: any) => {
        const item: any = {
          ciot: c.ciot ? String(c.ciot).replace(/\D/g, "") : "",
        };
        const docRaw = c.documento || c.cpf || c.cnpj;
        if (docRaw?.trim()) {
          const limpo = docRaw.replace(/[.\-/\s]/g, "").toUpperCase();
          item.documento = limpo;
          if (limpo.length === 11) {
            item.cpf = limpo;
          } else if (limpo.length === 14) {
            item.cnpj = limpo;
          }
        }
        return item;
      })
      .filter((c: any) => c.ciot.length > 0);

    if (ciotsValidos.length > 0) {
      payload.ciots = ciotsValidos;
    } else {
      delete payload.ciots;
    }
  } else {
    delete payload.ciots;
  }
  delete (payload as any).cioTs;

  // 16. Vales-Pedágio
  if (payload.valesPedagio && payload.valesPedagio.length > 0) {
    const pedValidos = payload.valesPedagio
      .map((v) => {
        const item: any = {
          numeroComprovante: String(v.numeroComprovante || "").trim(),
          valorValePedagio: Number(v.valorValePedagio) || 0,
        };
        if (v.cnpjEmitenteValePedagio?.trim()) {
          const cnpj = v.cnpjEmitenteValePedagio
            .replace(/[^A-Za-z0-9]/g, "")
            .toUpperCase();
          if (cnpj) item.cnpjEmitenteValePedagio = cnpj;
        }
        const docRespRaw =
          v.documentoResponsavelPagamento ||
          v.cnpjResponsavelPagamento ||
          v.cpfResponsavelPagamento;
        if (docRespRaw?.trim()) {
          const limpo = docRespRaw.replace(/[.\-/\s]/g, "").toUpperCase();
          item.documentoResponsavelPagamento = limpo;
          if (limpo.length === 11) {
            item.cpfResponsavelPagamento = limpo;
          } else if (limpo.length === 14) {
            item.cnpjResponsavelPagamento = limpo;
          }
        }
        if (v.tipoValePedagio && String(v.tipoValePedagio).trim()) {
          item.tipoValePedagio = String(v.tipoValePedagio).trim();
        }
        if (v.categoriaCombinacaoVeicular && String(v.categoriaCombinacaoVeicular).trim()) {
          item.categoriaCombinacaoVeicular = String(v.categoriaCombinacaoVeicular).trim();
        }
        return item;
      })
      .filter((v) => v.numeroComprovante.length > 0 && v.valorValePedagio > 0);

    if (pedValidos.length > 0) {
      payload.valesPedagio = pedValidos;
    } else {
      delete payload.valesPedagio;
    }
  } else {
    delete payload.valesPedagio;
  }

  // 17. Contratantes
  if (payload.contratantes && payload.contratantes.length > 0) {
    const contValidos = payload.contratantes
      .map((c) => {
        const item: any = {};
        if (c.nomeContratante?.trim()) item.nomeContratante = c.nomeContratante.trim();
        const docRaw = c.documento || c.cpf || c.cnpj;
        if (docRaw?.trim()) {
          const limpo = docRaw.replace(/[.\-/\s]/g, "").toUpperCase();
          item.documento = limpo;
          if (limpo.length === 11) {
            item.cpf = limpo;
          } else if (limpo.length === 14) {
            item.cnpj = limpo;
          }
        }
        if (c.idEstrangeiro?.trim()) item.idEstrangeiro = c.idEstrangeiro.trim();
        return item;
      })
      .filter((c) => c.documento || c.cpf || c.cnpj || c.idEstrangeiro || c.nomeContratante);

    if (contValidos.length > 0) {
      payload.contratantes = contValidos;
    } else {
      delete payload.contratantes;
    }
  } else {
    delete payload.contratantes;
  }

  // 18. Pagamentos (ANTT Res. 5.862)
  if (payload.pagamentos && payload.pagamentos.length > 0) {
    const pagValidos = payload.pagamentos
      .map((p) => {
        const item: any = {
          valorTotalContrato: Number(p.valorTotalContrato) || 0,
          formaPagamento: Number(p.formaPagamento) === 1 ? 1 : 0,
          componentes: (p.componentes || []).map((comp) => ({
            tipoComponente: Number(comp.tipoComponente),
            valorComponente: Number(comp.valorComponente) || 0,
            descricaoOutro:
              Number(comp.tipoComponente) === 99
                ? comp.descricaoOutro?.trim() || "OUTROS"
                : undefined,
          })),
        };

        if (p.nomeBeneficiario?.trim()) item.nomeBeneficiario = p.nomeBeneficiario.trim();
        const docRaw =
          p.documento ||
          p.cpfBeneficiario ||
          p.cnpjBeneficiario ||
          p.documentoResponsavelPagamento ||
          p.cpfResponsavelPagamento ||
          p.cnpjResponsavelPagamento;
        if (docRaw?.trim()) {
          const limpo = docRaw.replace(/[.\-/\s]/g, "").toUpperCase();
          item.documento = limpo;
          if (limpo.length === 11) {
            item.cpfBeneficiario = limpo;
            item.cpfResponsavelPagamento = limpo;
          } else if (limpo.length === 14) {
            item.cnpjBeneficiario = limpo;
            item.cnpjResponsavelPagamento = limpo;
          }
        }
        if (p.idEstrangeiroBeneficiario?.trim()) {
          item.idEstrangeiroBeneficiario = p.idEstrangeiroBeneficiario.trim();
        }
        if (p.idEstrangeiroResponsavelPagamento?.trim()) {
          item.idEstrangeiroResponsavelPagamento = p.idEstrangeiroResponsavelPagamento.trim();
        }

        // Novos campos: vAdiant, tpAntecip, infBanc
        if (item.formaPagamento === 0) {
          item.valorAdiantamento = 0;
        } else if (p.valorAdiantamento !== undefined && p.valorAdiantamento !== null) {
          item.valorAdiantamento = Number(p.valorAdiantamento) || 0;
        }
        if (p.tipoAntecipacao !== undefined && p.tipoAntecipacao !== null) {
          item.tipoAntecipacao = Number(p.tipoAntecipacao) || 0;
        }

        // infBanc é uma escolha mutuamente exclusiva (<xs:choice>) no schema da SEFAZ:
        // 1. Chave PIX
        // 2. CNPJ da IPEF
        // 3. Conta Bancária (Código do Banco + Código da Agência)
        const temPix = Boolean(p.chavePixBancario?.trim());
        const temIpef = Boolean(p.cnpjInstituicaoPagamento?.trim());
        const temBanco = Boolean(p.codigoBanco?.trim() || p.codigoAgencia?.trim());

        if (temPix) {
          item.chavePixBancario = p.chavePixBancario!.trim();
          delete item.cnpjInstituicaoPagamento;
          delete item.codigoBanco;
          delete item.codigoAgencia;
        } else if (temIpef) {
          item.cnpjInstituicaoPagamento = p.cnpjInstituicaoPagamento!
            .replace(/[^A-Za-z0-9]/g, "")
            .toUpperCase();
          delete item.chavePixBancario;
          delete item.codigoBanco;
          delete item.codigoAgencia;
        } else if (temBanco) {
          if (p.codigoBanco?.trim()) {
            item.codigoBanco = p.codigoBanco.replace(/\D/g, "").slice(0, 5);
          }
          if (p.codigoAgencia?.trim()) {
            item.codigoAgencia = p.codigoAgencia.replace(/\D/g, "").slice(0, 10);
          }
          delete item.chavePixBancario;
          delete item.cnpjInstituicaoPagamento;
        }

        delete item.indicadorPagamentoBancario;

        // Parcelas se a prazo
        if (item.formaPagamento === 1 && p.parcelas && p.parcelas.length > 0) {
          item.parcelas = p.parcelas.map((par, idx) => ({
            numeroParcela: Number(par.numeroParcela) || idx + 1,
            dataVencimento: moment(par.dataVencimento, [
              "YYYY-MM-DD",
              "DD/MM/YYYY",
              moment.ISO_8601,
            ]).isValid()
              ? moment(par.dataVencimento, [
                  "YYYY-MM-DD",
                  "DD/MM/YYYY",
                  moment.ISO_8601,
                ]).format("YYYY-MM-DD")
              : String(par.dataVencimento),
            valorParcela: Number(par.valorParcela) || 0,
          }));
        }

        return item;
      })
      .filter((p) => p.valorTotalContrato > 0 && p.componentes.length > 0);

    if (pagValidos.length > 0) {
      payload.pagamentos = pagValidos;
    } else {
      delete payload.pagamentos;
    }
  } else {
    delete payload.pagamentos;
  }

  return payload;
}

export interface BancoCompeItem {
  codigo: string;
  nome: string;
  nomeCompleto?: string;
}

export const tabelaBancosCompe: BancoCompeItem[] = [
  { codigo: "001", nome: "Banco do Brasil", nomeCompleto: "Banco do Brasil S.A." },
  { codigo: "003", nome: "Banco da Amazônia", nomeCompleto: "Banco da Amazônia S.A." },
  { codigo: "004", nome: "Banco do Nordeste", nomeCompleto: "Banco do Nordeste do Brasil S.A." },
  { codigo: "021", nome: "Banestes", nomeCompleto: "BANESTES S.A. Banco do Estado do Espírito Santo" },
  { codigo: "033", nome: "Santander", nomeCompleto: "Banco Santander (Brasil) S.A." },
  { codigo: "041", nome: "Banrisul", nomeCompleto: "Banco do Estado do Rio Grande do Sul S.A." },
  { codigo: "047", nome: "Banese", nomeCompleto: "Banco do Estado de Sergipe S.A." },
  { codigo: "070", nome: "BRB", nomeCompleto: "BRB - Banco de Brasília S.A." },
  { codigo: "077", nome: "Banco Inter", nomeCompleto: "Banco Inter S.A." },
  { codigo: "085", nome: "Ailos / Cecred", nomeCompleto: "Cooperativa Central de Crédito Urbano - Ailos" },
  { codigo: "104", nome: "Caixa Econômica Federal", nomeCompleto: "Caixa Econômica Federal" },
  { codigo: "136", nome: "Unicred", nomeCompleto: "Unicred Cooperativa" },
  { codigo: "197", nome: "Stone", nomeCompleto: "Stone Instituição de Pagamento S.A." },
  { codigo: "208", nome: "BTG Pactual", nomeCompleto: "Banco BTG Pactual S.A." },
  { codigo: "212", nome: "Banco Original", nomeCompleto: "Banco Original S.A." },
  { codigo: "218", nome: "Banco BS2", nomeCompleto: "Banco BS2 S.A." },
  { codigo: "237", nome: "Bradesco", nomeCompleto: "Banco Bradesco S.A." },
  { codigo: "260", nome: "Nubank", nomeCompleto: "Nu Pagamentos S.A. - Nubank" },
  { codigo: "290", nome: "PagBank / PagSeguro", nomeCompleto: "PagBank - PagSeguro Internet S.A." },
  { codigo: "318", nome: "Banco BMG", nomeCompleto: "Banco BMG S.A." },
  { codigo: "323", nome: "Mercado Pago", nomeCompleto: "Mercado Pago IP Ltda" },
  { codigo: "336", nome: "C6 Bank", nomeCompleto: "Banco C6 S.A." },
  { codigo: "341", nome: "Itaú Unibanco", nomeCompleto: "Itaú Unibanco S.A." },
  { codigo: "389", nome: "Banco Mercantil", nomeCompleto: "Banco Mercantil do Brasil S.A." },
  { codigo: "422", nome: "Banco Safra", nomeCompleto: "Banco Safra S.A." },
  { codigo: "655", nome: "Banco Votorantim / BV", nomeCompleto: "Banco Votorantim S.A." },
  { codigo: "707", nome: "Banco Daycoval", nomeCompleto: "Banco Daycoval S.A." },
  { codigo: "748", nome: "Sicredi", nomeCompleto: "Banco Cooperativo Sicredi S.A." },
  { codigo: "756", nome: "Sicoob", nomeCompleto: "Banco Cooperativo Sicoob S.A." },
];

export const obterNomeBancoCompe = (codigo?: string | null): string | undefined => {
  if (!codigo || codigo.trim() === "") return undefined;
  const codLimpo = codigo.trim();
  const codPad = codLimpo.length < 3 ? codLimpo.padStart(3, "0") : codLimpo;
  const encontrado = tabelaBancosCompe.find(
    (b) => b.codigo === codLimpo || b.codigo === codPad
  );
  return encontrado ? `${encontrado.codigo} - ${encontrado.nome}` : undefined;
};

